/**
 * Mantine style imports:
 */
import "@fontsource-variable/inter";
// ‼️ import core package styles needs to be before the other mantine package styles
import "@mantine/core/styles.css";

import "@mantine/carousel/styles.css";
import "@mantine/charts/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/dropzone/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/tiptap/styles.css";

import React from "react";
import ReactDOM from "react-dom/client";
import { AppContainer } from "./App.tsx";

/**
 * Global css:
 */
import "./index.css";
import { initSentry } from "./sentry.ts";
import { storeTrackingParamsIfPresent } from "./utils/useTrackEvent.ts";

/**
 * Start capturing errors with Sentry early; we'll also wrap this into
 * our react-router within the main App component:
 */
initSentry();
storeTrackingParamsIfPresent();

/**
 * After a new deployment, cached HTML may reference old hashed assets that no longer exist.
 * Reloading fetches the new index.html with correct asset URLs and resolves the error.
 */
window.addEventListener("vite:preloadError", () => {
  window.location.reload();
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AppContainer />
  </React.StrictMode>,
);
